import * as moment from 'moment';

export class FileItem {
  id: number;
  name: string;
  nameShort: string;
  nameVeryShort: string;
  comment: string;
  oldComment?: string;
  oldNameShort?: string;
  createdDate: any;
  showEdit?: boolean;
  submitting?: boolean;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.comment = apiModel.comment;
    this.name = apiModel.name;
    this.nameShort = apiModel.origin || 'No name';
    if (this.nameShort.length > 52) {
      this.nameShort = apiModel.name.slice(0, 50) + '...';
    }
    if (this.nameShort.length > 12) {
      this.nameVeryShort = this.nameShort.slice(0, 10) + '...';
    } else {
      this.nameVeryShort = this.nameShort;
    }
    this.createdDate = moment(new Date(apiModel.created));
    return this;
  }
}
